import { PaletteOptions } from "@mui/material";
import {
  PRIMARY_COLOR,
  PRIMARY_DARK_COLOR,
  PRIMARY_LIGHT_COLOR,
  WHITE,
} from "../colors";
import { paletteShared } from "./shared";

export const paletteSender: PaletteOptions = {
  ...paletteShared,
  primary: {
    contrastText: WHITE,
    dark: PRIMARY_DARK_COLOR,
    light: PRIMARY_LIGHT_COLOR,
    main: PRIMARY_COLOR,
  },
} as const;
